import { Button, PreIcon } from '@advanza/ui'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import BaseModal, {
    BaseModalFooter,
    BaseModalHeader,
    BaseModalMainContent,
} from '@trustoo/components/modal/BaseModal'

export const DEMO_REQUEST_ACTION_CREATE = 'create'
export const DEMO_REQUEST_ACTION_REMOVE = 'remove'

export type DemoRequestAction =
    | typeof DEMO_REQUEST_ACTION_CREATE
    | typeof DEMO_REQUEST_ACTION_REMOVE

interface DemoRequestConfirmModalProps {
    action: DemoRequestAction
    onConfirm: () => void
}

const DemoRequestConfirmModal = NiceModal.create(
    ({ action, onConfirm }: DemoRequestConfirmModalProps) => {
        const modal = useModal()

        const onClose = () => {
            modal.resolve()
            modal.hide()
        }

        const isCreate = action === DEMO_REQUEST_ACTION_CREATE

        return (
            <BaseModal onClose={onClose}>
                <BaseModalHeader>
                    {isCreate ? 'Create Demo Request' : 'Remove Demo Request'}
                </BaseModalHeader>
                <BaseModalMainContent>
                    <PreIcon icon="info" primColor>
                        {isCreate
                            ? "This will create an example request visible in the provider's dashboard. It auto-expires after 24 hours."
                            : "This will remove the example request from the provider's dashboard."}
                    </PreIcon>
                </BaseModalMainContent>
                <BaseModalFooter>
                    <div className="row justify-end gap-2">
                        <Button appearance="secondary" onClick={onClose}>
                            Cancel
                        </Button>
                        <Button
                            appearance="primary"
                            onClick={() => {
                                onConfirm()
                                onClose()
                            }}>
                            {isCreate ? 'Create' : 'Remove'}
                        </Button>
                    </div>
                </BaseModalFooter>
            </BaseModal>
        )
    },
)

export default DemoRequestConfirmModal
